//index.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import ElementLocale from 'element-ui/lib/locale';

import locale from 'element-ui/lib/locale';
// 引入各个语言配置文件
import zh from './langs/zh';
import en from './langs/en';
import hk from './langs/hk';
import enLocale from 'element-ui/lib/locale/lang/en'//引入element英文语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'//引入element中文语言包
import hkLocale from 'element-ui/lib/locale/lang/zh-TW'//引入element中文语言包
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale:localStorage.getItem('locale') || 'hk', // 语言标识
    messages: {
        'zh': {...zh,...zhLocale},
        'en': {...en,...enLocale},
		'hk': {...hk,...hkLocale},
    },
	silentTranslationWarn: true,
})

locale.i18n((key, value) => i18n.t(key, value))
// ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n;